import styled from 'styled-components';
import { Button, Form } from 'antd';
import { media, colors } from 'settings/style';
import BaseModal from 'components/elements/baseModal';

/** Primary navy for auth accents (matches groups / explore UI). */
export const ACCENT = '#1a2744';
export const TEXT_SECONDARY = '#4b5563';
export const TEXT_MUTED = '#667085';
export const BORDER_INPUT = '#e4e7ec';

export const LoginModal = BaseModal;

export const AuthPage = styled.div`
  display: flex;
  justify-content: center;
  padding: 2.5rem 1rem 4rem;
  min-height: calc(100vh - 12rem);

  ${media.md`
    padding: 1.5rem 1rem 3rem;
  `}
`;

export const AuthPageCard = styled.div`
  width: 100%;
  max-width: 720px;
  padding: 2rem 1.5rem;
  border: 1px solid ${BORDER_INPUT};
  border-radius: 16px;
  background: ${colors.white};
  box-shadow: 0 12px 40px rgba(16, 24, 40, 0.08);

  ${media.md`
    padding: 1.5rem 1rem;
  `}
`;

export const LoginAuthPageCard = styled(AuthPageCard)`
  max-width: 440px;
`;

export const LoginBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LogoMark = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  color: #1a2744;

  svg,
  img {
    display: block;
    height: 56px;
    width: auto;
    max-width: 100%;
  }
`;

export const LoginHeading = styled.h2`
  margin: 0 0 8px;
  font-family: 'Playfair Display', Georgia, 'Times New Roman', serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: ${colors.grey900};
  text-align: center;
  line-height: 1.2;

  ${media.md`
    font-size: 1.5rem;
  `}
`;

export const LoginSubheading = styled.p`
  margin: 0 0 28px;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  font-size: 0.9375rem;
  color: ${TEXT_MUTED};
  text-align: center;
  line-height: 1.4;
`;

export const StyledForm = styled(Form)`
  width: 100%;
  max-width: 100%;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  .ant-form-item {
    margin-bottom: 18px;
  }

  .ant-form-item-label > label {
    color: ${TEXT_SECONDARY};
    font-weight: 600;
    font-size: 0.875rem;
    height: auto;
    line-height: 1.3;
    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  }

  .ant-form-item-label {
    padding-bottom: 6px;
  }

  .login-input-email,
  .auth-input-text {
    border-radius: 8px;
    border: 1px solid ${BORDER_INPUT};
    padding: 10px 12px;
    font-size: 0.9375rem;
    min-height: 42px;
    box-sizing: border-box;
  color: ${colors.grey900};
    background: #fff;

    &:hover {
      border-color: #1a2744;
    }

    &:focus,
    &.ant-input-focused {
      border-color: #1a2744;
      box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.18);
    }

    &::placeholder {
      color: #9ca3af;
    }
  }

  .auth-date-input.ant-picker {
    width: 100%;
    border-radius: 8px;
    border: 1px solid ${BORDER_INPUT};
    background: #fff;
    padding: 10px 12px;
    font-size: 0.9375rem;

    &:hover {
      border-color: #1a2744;
    }

    &.ant-picker-focused {
      border-color: #1a2744;
      box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.18);
    }

    input {
      font-size: 0.9375rem;
      color: ${colors.grey900};

      &::placeholder {
        color: #9ca3af;
      }
    }

    .ant-picker-suffix {
      color: ${TEXT_MUTED};
    }
  }

  .login-input-password.ant-input-affix-wrapper {
    border-radius: 8px;
    border: 1px solid ${BORDER_INPUT};
    padding: 0 12px;
    font-size: 0.9375rem;
    background: #fff;

    &:hover {
      border-color: #1a2744;
    }

    .ant-input {
      border: none;
      box-shadow: none;
      padding: 10px 0;
      font-size: inherit;
  color: ${colors.grey900};
      background: transparent;

      &::placeholder {
        color: #9ca3af;
      }
    }

    .anticon {
      color: ${TEXT_MUTED};
    }
  }

  .login-input-password.ant-input-affix-wrapper-focused {
    border-color: #1a2744;
    box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.18);
  }

  /* PhoneInput: prefix select + number in one row */
  .auth-phone-combo {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;

    .ant-select .ant-select-selector {
      border-radius: 8px !important;
      border: 1px solid ${BORDER_INPUT} !important;
      height: 42px !important;
      align-items: center;
      display: flex;
    }

    .ant-select:hover .ant-select-selector,
    .ant-select-focused .ant-select-selector {
      border-color: #1a2744 !important;
    }

    .ant-input-number {
      flex: 1;
      min-width: 0;
      border-radius: 8px;
      border: 1px solid ${BORDER_INPUT};
      background: #fff;
    }

    .ant-input-number-input-wrap {
      height: 42px;
    }

    .ant-input-number-input {
      height: 40px;
      padding: 8px 12px;
      font-size: 0.9375rem;
  color: ${colors.grey900};
    }

    .ant-input-number:hover,
    .ant-input-number-focused {
      border-color: #1a2744;
      box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.18);
    }
  }
`;

export const OptionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
  flex-wrap: wrap;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-checkbox-wrapper {
    color: ${TEXT_SECONDARY};
    font-size: 0.875rem;
    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #1a2744;
    border-color: #1a2744;
  }
`;

export const ForgotLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #1a2744;

  &:hover {
    text-decoration: underline;
    color: #243556;
  }
`;

export const SignInButton = styled(Button)`
  width: 100%;
  height: 46px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  border: none !important;
  box-shadow: none !important;
  background: #1a2744 !important;
  color: #fff !important;

  &:hover,
  &:focus {
    background: #243556 !important;
    color: #fff !important;
    border: none !important;
  }

  &:disabled {
    opacity: 0.65;
    color: #fff !important;
  }
`;

export const LoginFooter = styled.p`
  margin: 24px 0 0;
  text-align: center;
  font-size: 0.9375rem;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: ${TEXT_MUTED};
`;

export const SignUpLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  font-weight: 600;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #1a2744;

  &:hover {
    text-decoration: underline;
    color: #243556;
  }
`;

export const SignupAvatarRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const SignupPictureHint = styled.span`
  color: #c62828;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.35;
  max-width: 220px;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
`;

export const SignupRecordingNotice = styled.p`
  margin: 0 0 18px;
  color: ${TEXT_MUTED};
  font-size: 0.8125rem;
  line-height: 1.55;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
`;

export const SignupRiskAcknowledgement = styled.div`
  margin: 0 0 20px;
  padding: 14px 16px;
  border: 1px solid ${BORDER_INPUT};
  border-radius: 10px;
  background: #f9fafb;

  .ant-checkbox-wrapper {
    align-items: flex-start;
  }

  .ant-checkbox {
    margin-top: 2px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const SignupRiskAcknowledgementText = styled.span`
  display: inline-block;
  color: ${TEXT_SECONDARY};
  font-size: 0.8125rem;
  line-height: 1.55;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  a {
    color: ${ACCENT};
    text-decoration: underline;
  }
`;
